import { ReactNativeModal } from './modal';
export { ReactNativeModal } from './modal';
export default ReactNativeModal;
